export const SET_ORDER_NOT_PARTIAL_DATA = "SET_ORDER_NOT_PARTIAL_DATA";
export const SET_MART_HEALTH_DASHBOARD_LIST_DATA = "SET_MART_HEALTH_DASHBOARD_LIST_DATA";
export const RESET_MART_HEALTH_DASHBOARD_REDUCER = "RESET_MART_HEALTH_DASHBOARD_REDUCER";